var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-select',{attrs:{"size":_vm.size,"options":_vm.options},on:{"input":_vm.input},model:{value:(_vm.companyId),callback:function ($$v) {_vm.companyId=$$v},expression:"companyId"}})}
var staticRenderFns = []

export { render, staticRenderFns }